import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

import H2 from "../components/H2"
import events from '../data/events';

import { formatDate, formatDateRange } from '../utils/format-dates';

export default function Events() {

  const now = Date.now();
  const upcomingEvents = events.filter((event) => event.dateTimeTo ? (Date.parse(event.dateTimeTo) >= now) : (Date.parse(event.dateTime) >= now));
  const pastEvents = events.filter((event) => event.dateTimeTo ? (Date.parse(event.dateTimeTo) < now) : (Date.parse(event.dateTime) < now));
  const upcomingEventsSorted = [...upcomingEvents].sort((eventA, eventB) => (eventB.dateTime || eventB.dateTimeFrom) - (eventA.dateTime || eventA.dateTimeFrom));
  const pastEventsSorted = [...pastEvents].sort((eventA, eventB) => (eventB.dateTime || eventB.dateTimeFrom) - (eventA.dateTime || eventA.dateTimeFrom));

  const EventLink = ({event, children}) => (
    event.externalUrl ?
      <a href={event.externalUrl} target="_blank" rel="noopener noreferrer">{children}</a>
      : <Link to={`/events/${event.id}`}>{children}</Link>
  )

  const Event = ({event}) => (
    <div className="border">
      <EventLink event={event}><img src={process.env.PUBLIC_URL + "/img/events/" + event.id + "/" + event.banner} alt={event.title} /></EventLink>
      <EventLink event={event}><h3 className="border-l-2 p-4 border-bahyellow font-semibold text-lg">{event.title}</h3></EventLink>
      {((event.dateTimeFrom && event.dateTimeTo) || event.dateTime) &&
        <span className="block mt-2 px-4 text-sm">
          <FontAwesomeIcon icon={faCalendarAlt} className="mr-2"/>
          {event.dateTimeFrom && event.dateTimeTo ?
            formatDateRange(new Date(Date.parse(event.dateTimeFrom)), new Date(Date.parse(event.dateTimeTo)))
            : formatDate(new Date(Date.parse(event.dateTime)))
          }
        </span>
      }
      {event.location &&
        <span className="block px-4 text-sm">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2"/>
          {event.location}
        </span>
      }
      <p className="mt-2 px-4 text-sm">{event.summary}</p>
      <span className="block mt-2 mb-4 px-4 text-sm text-blue-500"><EventLink event={event}>+ Read more</EventLink></span>
    </div>
  );

  return (
    <div>
      <p className="mt-8">
        The Brussels-Africa Hub regularly organizes events around a certain topic. With these events we aim to:
      </p>
      <ol className="mt-4 list-decimal pl-8">
        <li>Showcase carefully selected, investible projects in Africa</li>
        <li>Offer a stage to African leaders to promote their policies towards improving development in the private sector</li>
        <li>Give the opportunity to African and Africa focused European entrepreneurs to defend their business in front of potential future investors</li>
        <li>Invite EU public figures to exchange on the topic of green finance</li>
        <li>Invite Academics and Researchers to share their view on the latest research on <i>"Sustainable &amp; Responsible Investment"</i> in Africa as well as the impact of <i>Brussels-Africa Hub</i>’s initiatives</li>
      </ol>
      <H2 title="Upcoming events" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-5">
        {upcomingEventsSorted.map((event) => <Event key={event.id} event={event} />)}
      </div>
      <H2 title="Past events" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-5">
        {pastEventsSorted.map((event) => <Event key={event.id} event={event} />)}
      </div>
    </div>
  );
}